import apiClient from './apiClient';

export interface ImagingDepartment {
    id: number;
    name: string;
    code: string;
    description?: string;
    location?: string;
}

export interface ImagingStudy {
    id: number;
    name: string;
    code: string;
    department_id: number;
    department?: ImagingDepartment;
    description?: string;
    preparation_instructions?: string;
    duration_minutes: number;
    requires_contrast: boolean;
}

interface PaginatedData<T> {
    data: T[];
    pagination?: { current_page: number; last_page: number; total: number };
}

export const imagingStudyService = {
    async search(query: string, departmentId?: number): Promise<ImagingStudy[]> {
        const params = new URLSearchParams();
        if (query) params.set('search', query);
        if (departmentId) params.set('department_id', String(departmentId));
        params.set('per_page', '30');

        const response = await apiClient.get<PaginatedData<ImagingStudy>>(
            `/imaging-studies?${params.toString()}`
        );
        return response.data.data;
    },

    async getAll(): Promise<ImagingStudy[]> {
        const response = await apiClient.get<PaginatedData<ImagingStudy>>(
            '/imaging-studies?per_page=200'
        );
        return response.data.data;
    },

    async getById(id: number): Promise<ImagingStudy> {
        const response = await apiClient.get<{ success: boolean; data: ImagingStudy }>(
            `/imaging-studies/${id}`
        );
        return response.data.data;
    },

    async getByDepartment(departmentId: number): Promise<ImagingStudy[]> {
        const response = await apiClient.get<PaginatedData<ImagingStudy>>(
            `/imaging-studies?department_id=${departmentId}&per_page=100`
        );
        return response.data.data;
    },
};

export default imagingStudyService;